/*
 * @Author: cc
 * @Date: 2020-05-12 14:36:52
 * @LastEditTime: 2021-03-30 13:56:11
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\components\util\trsDateRangePicker\trsDateRangePicker.js
 * @Description: 跨天选择时间组件
 * 本指令产生的原因：原石榴云工程的时间选择器不能同时满足可以跨天选择和可以选择年份的需求，所以重新提供本指令进行时间选择统一
 * 本指令基于对原来代码最小的修改和入侵，只需要将原来使用的trs-time-select替换为trs-date-range-picker即可，原来传入的属性均不用替换
 * 基于angular-daterangepicker工具完成，github访问地址：https://github.com/fragaria/angular-daterangepicker
 * angular-daterangepicker是基于DateRangePicker封装的适用于angularJs指令，如果要查询更多配置项请访问：http://www.daterangepicker.com/#options
 * 基于对时间选择器的统一，本指令默认是跨天选择，如果需要单天选择请传入自定义配置项，并且指定singleDatePicker为true，因为跨天选择和单天选择传入的值不同如果是单天选择还要传入singledate为控制器使用
 */
angular.module('components.util').directive('trsDateRangePicker', ['$window', '$filter', '$timeout', 'globleParamsSet', function($window, $filter, $timeout, globleParamsSet){
    return {
        scope: {
            placeholder: '@', // 占位符
            callback: '&', // 选择时间后回调控制器方法
            fromdate: '=', // 多天模式返回的开始时间
            untildate: '=', // 多天模式返回的截止时间
            customconfig: '=', // 自定义配置项
            singledate: '=', // 单天模式返回的时间
            // 需求说明，在报纸细览详情页等非列表的时候，点击X无意义，故新增此选项
            noallowclickclear: '@', // 是否允许用户点击X选项 默认不传 允许点击
        }, // 为了减少改动还是隔离作用域
        restrict: 'EA',
        templateUrl: './components/util/trsDateRangePicker/trsDateRangePicker.html',
        link: function(scope){
            initOptions();
            $timeout(() => {
                scope.dateRangePicker.options = angular.extend({}, scope.basicOptions, scope.customconfig);
                if (scope.customconfig && scope.customconfig.localeFormat){
                    scope.dateRangePicker.options.locale.format = scope.customconfig.localeFormat;
                }
                mergeOptions();
            }, 100);

            /**
             * [initOptions description] 初始化时间选择器配置
             * @return  {[type]}  [return description]
             */
            function initOptions() {
                if (scope.noallowclickclear) {
                    scope.noallowclickclear = true;
                } else {
                    scope.noallowclickclear = false;
                }
                // scope.allowclickclear == undefined ? scope.allowclickclear = true : scope.allowclickclear = false;
                scope.placeholder = scope.placeholder ? scope.placeholder : '选择日期';
                scope.basicOptions = {
                    drops: 'auto',
                    pickerClasses: 'custom-display', // angular-daterangepicker extra
                    buttonClasses: 'btn',
                    applyButtonClasses: 'btn-primary',
                    cancelButtonClasses: 'btn-danger',
                    alwaysShowCalendars: true, // 总是显示日历
                    showDropdowns: true, // 显示年月日
                    autoApply: true,
                    // 为了让可选择年限小一点 
                    maxDate: $window.moment(new Date()).add(10, 'years'),
                    minDate: $window.moment(new Date()).subtract(10, 'years'),
                    locale: { // 汉化
                        applyLabel: '确定',
                        separator: '至', // 默认" - "
                        format: 'YYYY-MM-DD', // 设置显示格式
                        cancelLabel: '取消',
                        fromLabel: '起始时间',
                        toLabel: '结束时间',
                        customRangeLabel: '手动选择',
                        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
                        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月',
                            '七月', '八月', '九月', '十月', '十一月', '十二月'
                        ],
                    },
                    ranges: {
                        '最近七天': [$window.moment().subtract(6, 'days'), $window.moment()],
                        '最近三十天': [$window.moment().subtract(29, 'days'), $window.moment()]
                    },
                    eventHandlers: {
                        'apply.daterangepicker': function() { // 点击确认的回调事件
                            dealTime();
                            $timeout(() => {
                                scope.callback();
                            }, 100); // 解决指令内时间修改后，控制器时间没改变的问题
                        }
                    }
                }; // 基础配置项
                scope.dateRangePicker = {
                    date: {startDate: null, endDate: null}, // 初始值为空
                    picker: null,
                    options: scope.basicOptions
                };
            }

            /**
             * [mergeOptions description] 合并配置项（如果有自定义配置项）
             * @return  {[type]}  [return description]
             */
            function mergeOptions() {
                // let formatTime = (scope.customconfig && scope.customconfig.localeFormat) || scope.basicOptions.locale.format;
                let formatTime = (scope.customconfig && scope.customconfig.localeFormat) ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
                if (scope.customconfig && !!scope.customconfig.singleDatePicker) {
                    if (scope.singledate) {
                        scope.dateRangePicker.date = scope.singledate = (scope.customconfig && scope.customconfig.localeFormat) ? $window.moment(scope.singledate).startOf('second') : $window.moment(scope.singledate).startOf('day');
                        scope.singledate = $filter('date')(scope.singledate._d || scope.singledate, formatTime).toString();
                    } else {
                        scope.dateRangePicker.date = null;
                    }
                    // 如果是单选框，有些东西不需要显示
                    // scope.dateRangePicker.date = scope.singledate;
                    scope.dateRangePicker.options.showCustomRangeLabel = false;
                    scope.dateRangePicker.options.ranges = null;
                } else {
                    if (scope.untildate) {
                        scope.untildate = $window.moment(scope.untildate).endOf('day');
                        scope.fromdate = $window.moment(scope.fromdate).startOf('day');
                        scope.dateRangePicker.date.startDate = scope.fromdate;
                        scope.dateRangePicker.date.endDate = scope.untildate;
                        scope.fromdate = $filter('date')(scope.fromdate._d || scope.fromdate, formatTime).toString();
                        scope.untildate = $filter('date')(scope.untildate._d || scope.untildate, formatTime).toString();
                    }
                }
                // if (scope.customconfig){
                // } else {
                //     if (scope.untildate) {
                //         scope.untildate = $window.moment(scope.untildate).endOf('day');
                //         scope.fromdate = $window.moment(scope.fromdate).startOf('day');
                //         scope.dateRangePicker.date.startDate = scope.fromdate;
                //         scope.dateRangePicker.date.endDate = scope.untildate;
                //         scope.fromdate = $filter('date')(scope.fromdate._d || scope.fromdate, scope.basicOptions.locale.format).toString();
                //         scope.untildate = $filter('date')(scope.untildate._d || scope.untildate, scope.basicOptions.locale.format).toString();
                //     }
                // }
            }

            /**
             * [dealTime description] 处理时间
             * @return  {[type]}  [return description]
             */
            function dealTime(){
                let formatTime = (scope.customconfig && scope.customconfig.localeFormat) ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
                if (scope.dateRangePicker.options.singleDatePicker){ // 区分单天模式和多天模式
                    scope.singledate = $filter('date')(scope.dateRangePicker.date._d, formatTime).toString();
                } else {
                    scope.fromdate = $filter('date')(scope.dateRangePicker.date.startDate._d, formatTime).toString();
                    scope.untildate = $filter('date')(scope.dateRangePicker.date.endDate._d, formatTime).toString();
                }
            }
            
            /*
            * [clearDate description] 清除时间
            * @return  {[type]}  [return description]
            * */
            scope.clearDate = function() {
                // 选择了时间以后 点击关闭 发起请求
                if (scope.dateRangePicker.options.singleDatePicker){ // 区分单天模式和多天模式
                    scope.singledate = '';
                    scope.dateRangePicker.date = scope.singledate;
                    scope.dateRangePicker.options.showCustomRangeLabel = false;
                } else {
                    scope.dateRangePicker.date.startDate = null;
                    scope.dateRangePicker.date.endDate = null;
                    scope.fromdate = '';
                    scope.untildate = '';
                }
                // 日历样式清空
                scope.dateRangePicker.picker.startDate = $window.moment().startOf('day');
                scope.dateRangePicker.picker.endDate = $window.moment().endOf('day');
                $timeout(() => {
                    scope.callback();
                }, 100);
                
            };
            
            scope.$watch('singledate', function() {
                if (scope.singledate) {
                    mergeOptions();
                }
            });
            scope.$watch('untildate', function() {
                if (scope.untildate) {
                    mergeOptions();
                }
            });
        }
    };
}]);
